import PromotionDetails from './PromotionDetails';

export default PromotionDetails;
